import axios from "axios";

const getBaseUrl = () => {
  return (
    process.env.REACT_APP_CHAT_MICROSERVICE_URL ||
    "http://localhost:8000/api/v1"
  );
};

// Generate or retrieve persistent voter ID
export const getVoterId = () => {
  let voterId = localStorage.getItem("dexkor_voter_id");
  if (!voterId) {
    voterId =
      "voter_" + Math.random().toString(36).substring(2, 11) + "_" + Date.now();
    localStorage.setItem("dexkor_voter_id", voterId);
  }
  return voterId;
};

export const getVoterEmail = () => {
  return localStorage.getItem("dexkor_voter_email") || "";
};

export const setVoterEmail = (email) => {
  if (email) {
    localStorage.setItem("dexkor_voter_email", email.trim());
  }
};

export const roadmapService = {
  // Get public roadmap items
  getPublicRoadmap: async (partnerId, status = "all", sort = "recent") => {
    if (!partnerId) return [];
    try {
      const voterId = getVoterId();
      const email = getVoterEmail();
      const response = await axios.get(`${getBaseUrl()}/roadmap/public/${partnerId}`, {
        params: { status, sort, voterId, email }
      });
      return response.data?.data || [];
    } catch (err) {
      console.error("Error fetching roadmap items:", err);
      return [];
    }
  },

  // Submit a new feature request
  createFeatureRequest: async (
    partnerId,
    { title, description, email, name }
  ) => {
    if (!partnerId) return null;
    try {
      const voterId = getVoterId();
      if (email) setVoterEmail(email);

      const response = await axios.post(`${getBaseUrl()}/roadmap/public/${partnerId}`, {
        title,
        description,
        email: email || getVoterEmail(),
        name: name || "User",
        voterId
      });
      return response.data?.data || null;
    } catch (err) {
      console.error("Error creating feature request:", err);
      return null;
    }
  },

  // Find similar / duplicate requests
  findSimilarRequests: async (partnerId, query) => {
    if (!partnerId || !query) return [];
    try {
      const response = await axios.post(`${getBaseUrl()}/roadmap/public/${partnerId}/match`, { query });
      return response.data?.data || [];
    } catch (err) {
      console.error("Error finding similar requests:", err);
      return [];
    }
  },

  // Toggle upvote
  toggleVote: async (partnerId, itemId) => {
    if (!partnerId || !itemId) return null;
    try {
      const voterId = getVoterId();
      const email = getVoterEmail();

      const response = await axios.post(`${getBaseUrl()}/roadmap/public/${partnerId}/${itemId}/vote`, {
        voterId,
        email
      });
      return response.data?.data || null;
    } catch (err) {
      console.error("Error toggling upvote:", err);
      return null;
    }
  },

  // Add comment
  addComment: async (partnerId, itemId, message, author, authorEmail) => {
    if (!partnerId || !itemId || !message) return null;
    try {
      const response = await axios.post(
        `${getBaseUrl()}/roadmap/public/${partnerId}/${itemId}/comment`,
        {
          message,
          author: author || "User",
          authorEmail: authorEmail || getVoterEmail()
        }
      );
      return response.data?.data || null;
    } catch (err) {
      console.error("Error adding comment to roadmap item:", err);
      return null;
    }
  }
};

export default roadmapService;
